import React from 'react';
import {
    Card, CardBody, Progress, FormText
} from 'reactstrap';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
//react-redux comm
import { connect } from 'react-redux';
import { store  } from '../../_helpers';
import SearchPanel from './pr-panel';
import PaginatedResult from './pr-result';
import ViewHeader from './view-header';
import ReportIcon from 'react-icons/lib/fa/wpforms';


// styling
import './style.css';
// import PdfIcon from 'react-icons/lib/md/picture-as-pdf'
// import ExcelIcon from 'react-icons/lib/md/insert-drive-file';
// import ToolTipItem from "../utils/tooltip";


// Actions
import { commonActions, apiActions,alertActions } from '../../_actions';
import {appConstants} from "../../_constants";
import { appHelpers } from '../../_helpers';
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import {commonService} from "../../_services";

const Categories = [
    { label: 'Lifting Operator', value: 'AirlineCode' },
    { label: 'Date Type', value: 'DateType' },
    { label: 'Status', value: 'PaymentStatus' },
    { label: 'Currency', value: 'Currency' },
];

const DateTypes = [
    { label: 'Invoice Date', value: 2, cat: 'DateType' },
    { label: 'Payment Date', value: 3, cat: 'DateType' }
];
const Status = [
    { label: 'Fully Paid', value: 111, cat: 'PaymentStatus' },
    { label: 'Partially Paid', value: 211, cat: 'PaymentStatus'},
    { label: 'Unpaid', value: 311, cat: 'PaymentStatus'},
    { label: 'Unmatched Payment', value: 411, cat: 'PaymentStatus'}
];

const Currency = [
    { label: 'NGN', value: 566 , cat:'Currency' },
    { label: 'USD', value: 840 , cat:'Currency' }
];

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class PaymentReconciliation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airlineName:null,
            startDate: new Date(),
            endDate: new Date(),
            url:`${appConstants.PAS_URL}/api/Payment/ReconciliationSearch`,
            excelUrl:`${appConstants.PAS_URL}/api/Aggregate/DownloadStatementOfTscReport?DownloadTypeId=1&AirlineName=`,
            catOptions: Categories,
            searchOptions: [],
            //searchArray: [{ label: 'Flight Date', value: 1, cat: 'DateType' }],
            searchArray: [{ label: 'Invoice Date', value: 2, cat: 'DateType' }],
            searchLabelKey: '',
            searchValueKey: '',
            status:Status,
            currency:Currency,
            dateTypes: DateTypes,
            airlines: [],
            selectValue: { label: 'Date Type', value: 'DateType' },
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                dismissible: true,
            },
            results: false,
            pdfRecords:null,
            excelRecords:null,
            contentErrorText:false,
            passengerDetails: false,
            pageSize: 10,
            currentPage: 0,
            totalFlightCounts: 1,
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        //    Fetch Airlines
        const reduxState = store.getState();
        if (reduxState.airlinesCarriers) {
            this.setState({airlines: this.formatAirlines(reduxState.airlinesCarriers.Results)});
        } else {
            this.fetchAirlines();
        }

        //Get today's records results
        this.handleCatChange({ label: 'Date Type', value: 'DateType' });

    }

    componentDidUpdate(prevProps, prevState) {
        const { clickBD } = this.state;
        if (clickBD) {
            // debugger;
            this.search(1);
            this.setState({ clickBD: false });
        }
    }

    //update selected category
    updateCatValue = (newValue) => {
        this.setState({
            selectValue: newValue
        });
        this.handleCatChange(newValue);
    }

    //populate the multi search options with appropriate category options
    handleCatChange = (option) => {
        if (option) {// incase all category options are remove
            switch (option.value) {
                case 'AirlineCode':
                    return this.setState({
                        searchOptions: this.state.airlines,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                case 'DateType':
                    return this.setState({
                        searchOptions: this.state.dateTypes,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                case 'Currency':
                    return this.setState({
                        searchOptions: this.state.currency,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                case 'PaymentStatus':
                    return this.setState({
                        searchOptions: this.state.status,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                default:
                    return this.state;
            }
        }
        return this.setState({ searchOptions: [], searchArray: [] });
    }

    // remove option if option in that category is already selected
    switchOptionsPerCategory = (currentArray, newArray, category) => {
        const { selectValue } = this.state;
        let currentCat = (category)? category : selectValue;
        let optionToReplace = currentArray.filter(option => option.cat === currentCat.value)[0];
        if (optionToReplace) {
            return newArray.filter(option => option.label !== optionToReplace.label);
        } else {
            return newArray;
        }
    }

    //update selected options categories
    handleSelectChange = (newValue, category) => {
        let currentArray = this.state.searchArray;
        //debugger;
        let newArray = (currentArray.length > 0) ? this.switchOptionsPerCategory(this.state.searchArray, newValue, category) : newValue;
        this.setState({ searchArray: newArray });
    }

    fetchAirlines = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                const { airlinesCarriers } = this.props;
                this.setState({airlines: this.formatAirlines(airlinesCarriers.Results)});
                dispatch(apiActions.endRequest());
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineCode';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Code;
            data.push(item);
        }

        return data;
    };

    converter = (item) => {
        const { airlinesCarriers } = this.props;
        const filteredAirline =  airlinesCarriers.Results.filter(airline => {
            return airline.Code === item;
        });
        if(filteredAirline.length!==0){
            return filteredAirline[0].Name;
        }
        else{
            return item;
        }
    }

    formatSearchParameters = (res) => {

        if(res.length > 0) {
            let searchParameters = {};
            res.map(parameter =>
                searchParameters[parameter.cat] = parameter.value
            )
            return searchParameters;
        }
        return {};
    }


    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    search = (pageNumber) => {
        const { dispatch } = this.props;
        const { searchArray, pageSize, startDate, endDate } = this.state;

        // searchArray: [{ label: 'Invoice Date', value: 202, cat: 'DateType' }],
        const hasdateType = searchArray.find(obj => obj.cat === 'DateType')
!hasdateType ? this.setState({contentErrorText: 'Select a Date Type'}) : this.setState({contentErrorText:false});
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            pageNumber = 1;
        }else{
            dispatch(apiActions.startRequest());
        }

       let fromPage = pageSize * (pageNumber - 1);

        // if((pageNumber - 1) > 0) {
        //     fromPage = 1;
        // }
        let searchParams = this.formatSearchParameters(searchArray);

        let payload = {
            "PageSize": pageSize,
            "From": fromPage,
            "Parameter": {
                ...searchParams,
                StartDate: moment(startDate).format('YYYY-MM-DD'),
                EndDate: moment(endDate).format('YYYY-MM-DD')
            }
        };
        let url = this.state.url;
        appHelpers.postRequest(url, payload,{'Content-Type':'application/json'})
            .then((res) => {
                this.setState({
                    results: res.data,
                    currentPage: pageNumber
                });
                dispatch(apiActions.endRequest());
            })
            .catch((error) => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                //dispatch(alertActions.error(errorMessage));
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                dispatch(apiActions.endRequest());
                this.setState({contentError: errorMessage})
            });
    };


    /*Download PDF and EXCEL DATA */
    downloadPdfAndExcel = (downloadType) => {
        const { dispatch } = this.props;
        const { searchArray, startDate, endDate } = this.state;
        let searchParams = this.formatSearchParameters(searchArray);
        const payload__ = {
            "PageSize": 100,
            "From": 0,
            "Parameter": {
                ...searchParams,
                StartDate: moment(startDate).format('YYYY-MM-DD'),
                EndDate: moment(endDate).format('YYYY-MM-DD')
            }
        };
        commonService.paymentReconciliation(payload__)
            .then((res) => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    let response = res.response.data.File;
                    window.open(response, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });
        dispatch(apiActions.startRequest());
    };
    /* Download PDF and EXCEL DATA end */

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        const {contentErrorText,catOptions, selectValue, searchOptions, searchLabelKey, searchValueKey, searchArray, contentError, currentPage, pageSize, results } = this.state;
        const { requesting, pageRequesting } = this.props;
        return (
            <div className="view">
                <ViewHeader notify={this.notify}/>
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}

                        { (!contentError && !pageRequesting) &&
                        <CardBody>
                            <h6 className="mb-4 text-uppercase">
                                Search Panel
                                {(!pageRequesting && results.TotalCount > 0) &&
                                    <FormText color="muted">
                                        <ReportIcon size="18" color="#43a8df"/>{appHelpers.numberWithCommasOnly(results.TotalCount)} records
                                    </FormText>
                                }
                            </h6>
                            <SearchPanel
                                contentErrorText={contentErrorText}
                                categories={catOptions}
                                selectedCat={selectValue}
                                multiOptions={searchOptions}
                                multiLabelKey={searchLabelKey}
                                multiValueKey={searchValueKey}
                                multiArray={searchArray}
                                onCatValueChange={this.updateCatValue}
                                onMultiValueChange={this.handleSelectChange}
                                onSearch={this.search}
                                startDateChange={startDate => this.setState({ startDate })}
                                endDateChange={endDate => this.setState({ endDate })} />

                            <CardBody>

                                {(!pageRequesting && results) &&
                                <div>
                                    <PaginatedResult
                                        downloadFile = {this.downloadPdfAndExcel}
                                        paymentResults={results.Results}
                                        currentPage={currentPage}
                                        navigate={this.search}
                                        pageSize={pageSize}
                                        totalCount={results.TotalCount}
                                        converter = {this.converter}
                                    />
                                </div>
                                }
                                {(!pageRequesting && !results) &&
                                <PageEmptyContent message='No record match your search!'/>
                                }
                            </CardBody>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        airlinesCarriers: state.airlinesCarriers,
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting
    };
}

export default connect(mapStateToProps)(PaymentReconciliation);



// WEBPACK FOOTER //
// ./src/views/payment-reconciliation/index.js